<template>
  <div class="support-page-wrap">
    <div class="d-flex align-items-center webinars-first-row">
      <h1> Техническая поддержка </h1>
    </div>
    <validation-observer
        v-slot="{ handleSubmit }"
        ref="refFormObserver"
    >
      <b-form @submit.stop.prevent="handleSubmit(submitSupportForm($event))" ref="supportForm">
        <div class="support-form-wrapper">
          <validation-provider
              v-slot="validationContext"
              name="model"
              :rules="{required: true}"
          >
            <b-form-group
                label="Тема вопроса"
                label-for="topic"
            >
              <b-form-input
                  placeholder="Введите тему вопроса"
                  id="topic"
                  :state="getValidationState(validationContext)"
                  v-model="form.topic"
                  trim
              />
              <b-form-invalid-feedback>
                Заполните данное поле
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <validation-provider
              v-slot="validationContext"
              name="model"
              :rules="{required: true}"
          >
            <b-form-group
                label="Номер телефона / email / telegram username"
                label-for="contact"
            >
              <b-form-input
                  placeholder="Введите контакты"
                  id="contact"
                  :state="getValidationState(validationContext)"
                  v-model="form.contact"
                  trim
              />
              <b-form-invalid-feedback>
                Заполните данное поле
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <validation-provider
              v-slot="validationContext"
              name="model"
          >
            <b-form-group
                label="Опишите проблему максимально подробно"
                label-for="question"
            >
              <b-form-textarea
                  id="question"
                  :state="getValidationState(validationContext)"
                  trim
                  v-model="form.question"
              ></b-form-textarea>
              <b-form-invalid-feedback>
                Заполните данное поле
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>


          <div class="form-group">
            <b-button variant="primary" type="submit">Отправить сообщение</b-button>
          </div>

        </div>
      </b-form>
    </validation-observer>
  </div>
</template>

<script>
import {createNamespacedHelpers} from 'vuex';
import SupportApi from '../../api/support';
import {BFormGroup, BFormInput, BForm, BFormInvalidFeedback, BFormTextarea, BButton} from 'bootstrap-vue'
import {ValidationObserver, ValidationProvider} from 'vee-validate'

const {mapState} = createNamespacedHelpers('user');

export default {
  name: 'Support',
  computed: {
    ...mapState({
      user: (state) => state.userData,
    }),
  },
  components: {
    BFormGroup,
    BFormInput,
    ValidationProvider,
    ValidationObserver,
    BForm,
    BFormInvalidFeedback,
    BFormTextarea,
    BButton
  },
  data() {
    return {
      form: {
        question: '',
        contact: '',
        topic: '',
      },
    };
  },
  methods: {
    submitSupportForm(event) {

      this.$refs.refFormObserver.validate().then(success => {
        if (success) {
          SupportApi.sendSupportMessage({
            ...this.form,
            user_id: this.user.id,
          })
              .then(() => {
                this.$bvToast.toast('Wait for the response in a few hours', {
                  title: `Success! We have got your message`,
                  variant: 'success',
                  solid: true,
                })

                this.form = {
                  question: '',
                  contact: '',
                  topic: '',
                };

                setTimeout(() => {
                  this.$refs.refFormObserver.reset();
                }, 500)
              })
              .catch(() => {
                this.$bvToast.toast('Please try again later', {
                  title: `Oops! Something went wrong...`,
                  variant: 'danger',
                  solid: true,
                })
              });
        }
      })
    },
    getValidationState({dirty, validated, valid = null}) {
      return dirty || validated ? valid : null;
    },
  },
};
</script>

<style scoped>
  .support-page-wrap{
    max-width: 800px;
  }
</style>
